<template>
  <div class="upper-subpanel--inside">
    <div class="col-6">
      <DrugInfo/>
    </div>
    <div class="col-6">
      <ConfirmFlow 
        :confirmProgress="confirmProgress"
        v-if="currentProgress === 'confirm'" 
        v-on:confirmationFinish="getConfirmData"></ConfirmFlow>    
      <Loader v-if="currentProgress === 'finish'"/>
    </div>
  </div>
</template>

<script>
import MultiFlowBase from '../ComponentBase/MultiFlowBase';
import DrugInfo from '../flowComp/DrugInfo';
import ConfirmFlow from './ConfirmFlow';
import Loader from '../common/Loader';

export default {
  name: 'multiFlow',
  extends: MultiFlowBase,
  props: [],
  data() {
    return {
    };
  },
  components: {
    DrugInfo,
    ConfirmFlow,
    Loader,
  },
  async mounted() {
    await this.$store.dispatch('fromFirstDrugInDevice');
  },
  methods: {
    getConfirmData() {
      this.nextProgress();
      if (this.nextDrugInDevice !== null) {
        // check whether next index is over the keys' array length
        console.log('get confirm data');
        this.$store.dispatch('toNextDrugInDevice');
        setTimeout(() => {
          this.resetProgress();
        }, 200);
      } else {
        console.log('leave multiflow');
        this.$emit('setAllConfirmData');
      }
    },
  },
  computed: {
  },
};
</script>



// WEBPACK FOOTER //
// MultiFlow.vue?522a2880